export const palette = {
  background: {
    default: '#F6F7F9',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1C2536',
    secondary: '#667085',
  },
  divider: '#E7E9EE',
  primary: {
    main: '#2169F5',
    light: '#2169F5',
    dark: '#0F347C',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFCD75',
    light: '#0000009A',
    dark: '#377DCE',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FB8C00',
    light: '#FF9800',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#0288D1',
    light: '#E6F3FE',
    dark: '#01579B',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
    dark: '#1B5E20',
    contrastText: '#FFFFFF',
  },
};

export const otherColors = {
  apptHover: '#F4F6F8',
  formCardBg: '#F7F8F9',
  lightDivider: 'rgba(0, 0, 0, 0.12)',
  tableRow: 'rgba(0,0,0,0.87)',
  sidebarItemHover: '#F6F9FF',
  disabled: 'rgba(0,0,0,0.38)',
  solidLine: '#DFE5E9',
};
